import { Button, Card, DatePicker, Space, Select } from "antd";
import React, { useEffect, useState } from "react";

import "./AnalysisCard.scss";
import { observer } from "mobx-react";
import moment from "moment";
const { RangePicker } = DatePicker;
const { Option } = Select;

export const AnalysisCard = observer(({ title, children, onStart }) => {
  const [interval, setInterval] = useState("1w");
  const [period, setPeriod] = useState([moment().subtract(12, "weeks"), moment()]);

  const start = () => {
    let [from, to] = period;
    to = to.utc().endOf("day");
    from = from.utc().startOf("day");
    onStart({ interval, period: [from, to] });
  };

  useEffect(() => {
    start();
  }, []);

  return (
    <Card
      size="small"
      title={title}
      className="analysis-card"
      extra={
        <Space>
          <RangePicker
            clearIcon={false}
            size="small"
            value={period as any}
            onChange={(dates) => setPeriod(dates as any)}
          ></RangePicker>
          <Select size="small" defaultValue={interval} style={{ width: 120 }} onChange={(e) => setInterval(e)}>
            <Option value="1w">by week</Option>
            <Option value="1M">by month</Option>
            <Option value="1q">by quarter</Option>
            <Option value="1y">by year</Option>
          </Select>
          <Button size="small" onClick={start}>
            Start
          </Button>
        </Space>
      }
    >
      {children}
    </Card>
  );
});
